import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ticket-row"
// Shows a ticket as a collapsed summary with an Edit toggle. The editor is
// rendered visible by default (so it works without JS); on connect we collapse
// it unless the row was flagged to start expanded.
export default class extends Controller {
  static targets = [
    "summary",
    "editor",
    "summaryName",
    "summaryDetail",
    "name",
    "price",
    "capacity",
    "tax",
    "taxBehaviorField",
    "currencyCode",
  ];
  static values = { expanded: Boolean };

  connect() {
    this.justToggled = false;
    this.render();
  }

  toggle() {
    this.justToggled = true;
    this.expandedValue = !this.expandedValue;
  }

  expandedValueChanged() {
    this.render();
  }

  inputChanged() {
    this.updateSummary();
    this.updateTaxBehaviorVisibility();
  }

  // Tax inclusive/exclusive only matters for a paid ticket with a tax rate.
  // It renders visible (so it works without JS); we hide it when irrelevant.
  updateTaxBehaviorVisibility() {
    if (!this.hasTaxBehaviorFieldTarget) return;
    const taxSelected = this.hasTaxTarget && this.taxTarget.value !== "";
    const price = this.hasPriceTarget ? parseFloat(this.priceTarget.value) : 0;
    this.taxBehaviorFieldTarget.hidden = !(taxSelected && price > 0);
  }

  render() {
    if (this.hasEditorTarget) this.editorTarget.hidden = !this.expandedValue;
    if (this.hasSummaryTarget) this.summaryTarget.hidden = this.expandedValue;
    this.updateSummary();
    this.updateTaxBehaviorVisibility();
    if (this.expandedValue && this.justToggled && this.hasNameTarget) {
      this.nameTarget.focus();
    }
    this.justToggled = false;
  }

  updateSummary() {
    if (!this.hasSummaryNameTarget) return;

    const name = this.hasNameTarget ? this.nameTarget.value.trim() : "";
    this.summaryNameTarget.textContent = name || "Untitled ticket";

    const price = this.hasPriceTarget ? this.priceTarget.value.trim() : "";
    const currency = this.hasCurrencyCodeTarget
      ? this.currencyCodeTarget.textContent.trim()
      : "";
    const priceLabel =
      !price || parseFloat(price) === 0 ? "Free" : `${currency}${price}`;

    const capacity = this.hasCapacityTarget
      ? this.capacityTarget.value.trim()
      : "";
    const capacityLabel = capacity
      ? `${Number(capacity).toLocaleString()} available`
      : "Unlimited";

    const taxLabel = this.hasTaxTarget
      ? this.taxTarget.options[this.taxTarget.selectedIndex].text
      : "No tax";

    this.summaryDetailTarget.textContent = [
      priceLabel,
      capacityLabel,
      taxLabel,
    ].join(" · ");
  }
}
